import { createContext, SetStateAction, Dispatch } from "react";

import { FormInstance } from "antd";

import { ActivitiesSectionForm } from "../../../../../AP/Steps/StepFour/contexts/StepFourForm";

interface StepFourFormContextProps {

    validitySectionForm:                FormInstance<{ validityDate: any }>;

    methodSelectedFromStepThree:        any; // todo: ver que es...
    setMethodSelectedFromStepThree:     Dispatch<SetStateAction<any>>;

    errorCreditCardMessage:             string;
    setErrorCreditCardMessage:          Dispatch<SetStateAction<string>>;

    activitiesSectionForm:              FormInstance<ActivitiesSectionForm>;

    activitiesFormValues:               ActivitiesSectionForm | undefined;
    setActivitiesFormValues:            Dispatch<SetStateAction<ActivitiesSectionForm | undefined>>;
    
    stepFourForm:                       FormInstance<any> | undefined;
    setStepFourForm:                    Dispatch<SetStateAction<FormInstance<any> | undefined>>;

}

export const StepFourFormContext = createContext({} as StepFourFormContextProps);